import { render, staticRenderFns } from "./AdjustScoreLabelButton.vue?vue&type=template&id=11b27002&"
import script from "./AdjustScoreLabelButton.vue?vue&type=script&lang=js&"
export * from "./AdjustScoreLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports